module.exports = __webpack_public_path__ + "img/client15.5e71e964.svg";